import { ClaimCandidatesGroupedTable } from "../../components/claims/ClaimCandidatesGroupedTable";
import { PageHeader } from "../../components/layout/PageHeader";

export function ValueRecoveredReportPage({ basePath = "/reports/recovered" }: { basePath?: string } = {}) {
  return (
    <div className="page-stack">
      <PageHeader
        title="Value recovered"
        description="Claim groups marked recovered. These amounts feed the Value Recovered KPI on the overview."
      />
      <ClaimCandidatesGroupedTable
        statusFilter={["recovered"]}
        detailPath={(id) => `${basePath}/${id}`}
        showActions
        actionPreset="recovered"
        emptyMessage="No recovered claims in this period."
      />
    </div>
  );
}
